export default __webpack_public_path__ + "static/media/network-hub-banner.2a721d7b.png";